import { render, staticRenderFns } from "./Tech.vue?vue&type=template&id=5382b756&scoped=true"
import script from "./Tech.vue?vue&type=script&lang=js"
export * from "./Tech.vue?vue&type=script&lang=js"
import style0 from "./Tech.vue?vue&type=style&index=0&id=5382b756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5382b756",
  null
  
)

export default component.exports